module.exports = __webpack_public_path__ + "img/1-23.bea040d0.jpg";